export default __webpack_public_path__ + "static/media/bizumApp.405a3cd3.png";